/* AARHEIM Theme: Warenkorb-Seitenleiste, Hero, Produktkarten, Produktseite, Set-Box.
   Ohne JavaScript funktioniert der Shop weiter (Links führen zu Warenkorb- und Produktseiten). */
(() => {
  "use strict";

  const A = window.aarheim || { routes: {}, t: {} };
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const reduceMotion = () => window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  const url = (path) => root + path.replace(/^\//, "");
  const esc = (s) =>
    String(s ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c]);

  /* ---------- Geld ---------- */
  function formatMoney(cents) {
    const format = A.moneyFormat || "{{amount_with_comma_separator}} €";
    const value = Number(cents || 0) / 100;
    const group = (n, dec, thou, sep) => {
      const [int, frac] = n.toFixed(dec).split(".");
      return int.replace(/\B(?=(\d{3})+(?!\d))/g, thou) + (frac ? sep + frac : "");
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, kind) => {
      switch (kind) {
        case "amount_no_decimals": return group(value, 0, ",", ".");
        case "amount_with_comma_separator": return group(value, 2, ".", ",");
        case "amount_no_decimals_with_comma_separator": return group(value, 0, ".", ",");
        case "amount_with_apostrophe_separator": return group(value, 2, "'", ".");
        case "amount_with_space_separator": return group(value, 2, " ", ",");
        default: return group(value, 2, ",", ".");
      }
    });
  }
  const tpl = (text, vars) => String(text || "").replace(/\{\{\s*(\w+)\s*\}\}/g, (_, k) => vars[k] ?? "");

  /* ---------- Lieferfenster (Werktage, bundesweite Feiertage) ---------- */
  function easter(y) {
    const a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4;
    const f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31), day = ((h + l - 7 * m + 114) % 31) + 1;
    return Date.UTC(y, month - 1, day);
  }
  const iso = (d) => d.toISOString().slice(0, 10);
  const holidayCache = {};
  function holidays(y) {
    if (!holidayCache[y]) {
      const e = easter(y);
      const rel = (n) => iso(new Date(e + n * 86400000));
      holidayCache[y] = new Set([`${y}-01-01`, rel(-2), rel(1), `${y}-05-01`, rel(39), rel(50), `${y}-10-03`, `${y}-12-25`, `${y}-12-26`]);
    }
    return holidayCache[y];
  }
  const isWorkday = (d) => d.getUTCDay() % 6 !== 0 && !holidays(d.getUTCFullYear()).has(iso(d));
  function addWorkdays(start, n) {
    const d = new Date(start);
    while (n > 0) {
      d.setUTCDate(d.getUTCDate() + 1);
      if (isWorkday(d)) n--;
    }
    return d;
  }
  function deliveryText() {
    const today = new Date(
      new Intl.DateTimeFormat("en-CA", { timeZone: "Europe/Berlin", year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date()) + "T00:00:00Z"
    );
    const fmt = new Intl.DateTimeFormat("de-DE", { weekday: "short", day: "numeric", month: "numeric", timeZone: "UTC" });
    const from = fmt.format(addWorkdays(today, A.deliveryMin || 7));
    const to = fmt.format(addWorkdays(today, A.deliveryMax || 12));
    return tpl(A.t.eta, { window: `${from} bis ${to}` });
  }

  /* ---------- Kurzmeldung ---------- */
  let toastTimer;
  function toast(text) {
    let el = $(".toast");
    if (!el) {
      el = document.createElement("div");
      el.className = "toast";
      el.setAttribute("role", "status");
      document.body.appendChild(el);
    }
    el.textContent = text;
    el.classList.add("is-visible");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove("is-visible"), 2600);
  }

  /* ---------- Seitenleisten (natives <dialog>) ---------- */
  let lastTrigger = null;
  function openDialog(dialog, trigger) {
    if (!dialog || dialog.open) return;
    lastTrigger = trigger || document.activeElement;
    dialog.showModal();
    document.documentElement.classList.add("no-scroll");
  }
  function closeDialog(dialog) {
    if (!dialog || !dialog.open) return;
    dialog.close();
  }
  $$("dialog.drawer").forEach((dialog) => {
    dialog.addEventListener("close", () => {
      document.documentElement.classList.remove("no-scroll");
      if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
    });
    // Klick auf den abgedunkelten Hintergrund schließt
    dialog.addEventListener("click", (e) => {
      if (e.target === dialog) closeDialog(dialog);
    });
    $$("[data-drawer-close]", dialog).forEach((b) => b.addEventListener("click", () => closeDialog(dialog)));
  });
  $$("[data-menu-open]").forEach((b) => b.addEventListener("click", () => openDialog($("#menu-drawer"), b)));

  /* ---------- Warenkorb ---------- */
  const drawer = $("#cart-drawer");
  const onCartPage = document.body.classList.contains("template-cart");

  async function fetchJSON(path, options) {
    const res = await fetch(url(path), {
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      ...options,
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw Object.assign(new Error(data.description || data.message || "Fehler"), { data });
    return data;
  }
  const getCart = () => fetchJSON("cart.js");

  function updateCount(count) {
    $$("[data-cart-count]").forEach((el) => (el.textContent = count));
    $$("[data-cart-count-badge]").forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
    });
    $$("[data-cart-label]").forEach((el) => (el.textContent = el.textContent.replace(/\d+/, count)));
  }

  function lineHTML(item, index) {
    const img = item.featured_image && item.featured_image.url
      ? `<img class="line__img" src="${esc(item.featured_image.url)}&width=200" alt="" width="80" height="80" loading="lazy">`
      : `<span class="line__img"></span>`;
    const variant = item.variant_title && item.variant_title !== "Default Title" ? `<p class="line__meta">${esc(item.variant_title)}</p>` : "";
    const discounts = (item.line_level_discount_allocations || [])
      .map((d) => `<p class="line__meta success">${esc(d.discount_application.title)} (−${formatMoney(d.amount)})</p>`)
      .join("");
    const was = item.original_line_price > item.final_line_price ? `<s class="line__meta">${formatMoney(item.original_line_price)}</s><br>` : "";
    const line = index + 1;
    return `
      <div class="line">
        <a href="${esc(item.url)}" tabindex="-1" aria-hidden="true">${img}</a>
        <div>
          <a class="line__title" href="${esc(item.url)}">${esc(item.product_title)}</a>
          ${variant}${discounts}
          <div class="qty" role="group" aria-label="Menge ${esc(item.product_title)}">
            <button type="button" data-qty="${line}" data-to="${item.quantity - 1}" aria-label="Menge verringern"><svg class="icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14" stroke="currentColor" stroke-width="1.5" fill="none"/></svg></button>
            <output aria-live="polite">${item.quantity}</output>
            <button type="button" data-qty="${line}" data-to="${item.quantity + 1}" aria-label="Menge erhöhen"><svg class="icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M12 5v14" stroke="currentColor" stroke-width="1.5" fill="none"/></svg></button>
          </div>
        </div>
        <div class="line__price">
          ${was}${formatMoney(item.final_line_price)}
          <div><button type="button" class="line__remove" data-qty="${line}" data-to="0">${esc(A.t.remove)}</button></div>
        </div>
      </div>`;
  }

  function freeShippingHTML(total) {
    const goal = A.freeShippingCents || 4900;
    const reached = total >= goal;
    const pct = Math.min(100, Math.round((total / goal) * 100));
    const text = reached ? A.t.freeShippingReached : tpl(A.t.freeShippingLeft, { amount: formatMoney(goal - total) });
    return { reached, html: `<p>${esc(text)}</p><div class="free-shipping__bar" aria-hidden="true"><div class="free-shipping__fill" style="width:${pct}%"></div></div>` };
  }

  async function renderUpsell(cart, container) {
    if (!cart.items.length) return;
    try {
      const inCart = new Set(cart.items.map((i) => i.product_id));
      const rec = await fetchJSON(`recommendations/products.json?product_id=${cart.items[0].product_id}&limit=6&intent=related`);
      const picks = (rec.products || []).filter((p) => !inCart.has(p.id) && p.available).slice(0, 2);
      if (!picks.length) return;
      const box = document.createElement("div");
      box.className = "upsell";
      box.innerHTML = `<h3 class="upsell__title">Passt dazu</h3>` + picks.map((p) => {
        const v = p.variants.find((x) => x.available) || p.variants[0];
        const img = p.featured_image ? `<img src="${esc(p.featured_image)}&width=160" alt="" width="56" height="56" loading="lazy">` : "<span></span>";
        return `<div class="upsell__item">${img}<div><a href="${esc(p.url)}" class="line__title">${esc(p.title)}</a><p class="line__meta">${formatMoney(v.price)}</p></div>
          <button type="button" class="button button--secondary" data-upsell-add="${v.id}" aria-label="${esc(p.title)} in den Warenkorb">+</button></div>`;
      }).join("");
      container.appendChild(box);
    } catch (_) { /* Empfehlungen sind optional */ }
  }

  function renderCart(cart) {
    updateCount(cart.item_count);
    if (!drawer) return;
    const lines = $("[data-cart-lines]", drawer);
    const foot = $("[data-cart-foot]", drawer);
    if (!cart.items.length) {
      lines.innerHTML = `<div class="drawer__empty"><p>${esc(A.t.empty)}</p><a class="button button--primary" href="${url("collections/all")}">Zur Kollektion</a></div>`;
      foot.hidden = true;
      return;
    }
    foot.hidden = false;
    lines.innerHTML = cart.items.map(lineHTML).join("");
    renderUpsell(cart, lines);

    const fs = $("[data-free-shipping]", drawer);
    const info = freeShippingHTML(cart.total_price);
    fs.innerHTML = info.html;
    fs.classList.toggle("is-reached", info.reached);

    $("[data-cart-subtotal]", drawer).textContent = formatMoney(cart.items_subtotal_price);
    const discountRow = $("[data-cart-discount-row]", drawer);
    const orderDiscount = (cart.cart_level_discount_applications || []).reduce((s, d) => s + d.total_allocated_amount, 0);
    discountRow.hidden = orderDiscount === 0;
    $("[data-cart-discount]", drawer).textContent = "−" + formatMoney(orderDiscount);

    const status = $("[data-discount-status]", drawer);
    const codes = cart.discount_codes || [];
    if (codes.length && !status.dataset.busy) {
      const c = codes[codes.length - 1];
      status.textContent = c.applicable ? `Code ${c.code} ist aktiv.` : `Code ${c.code} gilt für diesen Warenkorb nicht.`;
      status.className = "discount-form__status " + (c.applicable ? "is-ok" : "is-error");
    }
  }

  async function refreshCart(open) {
    try {
      const cart = await getCart();
      renderCart(cart);
      if (open) openDialog(drawer);
      return cart;
    } catch (_) {
      if (open) window.location.href = url("cart");
    }
  }

  async function changeLine(line, quantity) {
    if (onCartPage) {
      window.location.href = url(`cart/change?line=${line}&quantity=${quantity}`);
      return;
    }
    try {
      const cart = await fetchJSON("cart/change.js", { method: "POST", body: JSON.stringify({ line, quantity }) });
      renderCart(cart);
    } catch (err) {
      toast(err.message);
      refreshCart();
    }
  }

  async function addItems(items, trigger) {
    if (trigger) {
      trigger.classList.add("is-loading");
      trigger.disabled = true;
    }
    try {
      await fetchJSON("cart/add.js", { method: "POST", body: JSON.stringify({ items }) });
      if (onCartPage) {
        window.location.reload();
        return;
      }
      await refreshCart(true);
    } catch (err) {
      toast(err.message || "Das hat nicht geklappt.");
    } finally {
      if (trigger) {
        trigger.classList.remove("is-loading");
        trigger.disabled = false;
      }
    }
  }

  if (drawer) {
    $$("[data-cart-open]").forEach((link) =>
      link.addEventListener("click", (e) => {
        if (onCartPage) return;
        e.preventDefault();
        refreshCart(true);
      })
    );
    drawer.addEventListener("click", (e) => {
      const q = e.target.closest("[data-qty]");
      if (q) changeLine(Number(q.dataset.qty), Math.max(0, Number(q.dataset.to)));
      const up = e.target.closest("[data-upsell-add]");
      if (up) addItems([{ id: Number(up.dataset.upsellAdd), quantity: 1 }], up);
    });

    // Gutscheincode: wird im Warenkorb hinterlegt und in der Kasse automatisch übernommen
    const form = $("[data-discount-form]", drawer);
    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      const input = $("input", form);
      const status = $("[data-discount-status]", form);
      const code = input.value.trim().toUpperCase();
      if (!code) return;
      status.dataset.busy = "1";
      status.className = "discount-form__status";
      status.textContent = "Wird geprüft …";
      try {
        const existing = ((await getCart()).discount_codes || []).map((c) => c.code).filter((c) => c !== code);
        const cart = await fetchJSON("cart/update.js", { method: "POST", body: JSON.stringify({ discount: [...existing, code].join(",") }) });
        const hit = (cart.discount_codes || []).find((c) => c.code.toUpperCase() === code);
        const ok = hit && hit.applicable;
        status.textContent = ok ? `Code ${code} ist aktiv.` : `Der Code ${code} ist ungültig oder gilt für diesen Warenkorb nicht.`;
        status.className = "discount-form__status " + (ok ? "is-ok" : "is-error");
        if (ok) input.value = "";
        delete status.dataset.busy;
        renderCart(cart);
      } catch (_) {
        delete status.dataset.busy;
        status.textContent = "Der Code konnte gerade nicht geprüft werden. Du kannst ihn auch in der Kasse eingeben.";
        status.className = "discount-form__status is-error";
      }
    });
  }

  /* ---------- Hero-Folien ---------- */
  $$("[data-slider]").forEach((slider) => {
    const track = $("[data-slider-track]", slider);
    const dots = $$("[data-slider-dot]", slider);
    const count = track.children.length;
    const index = () => Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
    const goTo = (i) => track.scrollTo({ left: ((i + count) % count) * track.clientWidth, behavior: reduceMotion() ? "auto" : "smooth" });
    track.addEventListener("scroll", () => {
      const i = index();
      dots.forEach((d, n) => d.setAttribute("aria-current", String(n === i)));
    }, { passive: true });
    dots.forEach((d) => d.addEventListener("click", () => goTo(Number(d.dataset.sliderDot))));
    const prev = $("[data-slider-prev]", slider);
    const next = $("[data-slider-next]", slider);
    if (prev) prev.addEventListener("click", () => goTo(index() - 1));
    if (next) next.addEventListener("click", () => goTo(index() + 1));
  });

  /* ---------- Produktkarten: Farbe per Maus zeigen, per Tippen wählen ---------- */
  function showLayer(card, color) {
    const layers = $$("[data-layer]", card);
    const target = layers.find((l) => l.dataset.layer === color) || layers.find((l) => l.dataset.layer === "");
    layers.forEach((l) => l.classList.toggle("is-active", l === target));
  }
  $$("[data-card]").forEach((card) => {
    const swatches = $$("[data-swatch]", card);
    if (!swatches.length) return;
    const link = $("[data-card-link]", card);
    const baseUrl = link ? link.getAttribute("href") : card.dataset.url;
    let chosen = "";
    swatches.forEach((sw) => {
      sw.addEventListener("mouseenter", () => { showLayer(card, sw.dataset.swatch); card.classList.add("has-swatch-choice"); });
      sw.addEventListener("focus", () => showLayer(card, sw.dataset.swatch));
      sw.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        chosen = sw.dataset.swatch;
        swatches.forEach((s) => s.setAttribute("aria-pressed", String(s === sw)));
        showLayer(card, chosen);
        card.classList.add("has-swatch-choice");
        // Der Link öffnet das Produkt danach direkt in der gewählten Farbe
        if (link) {
          const u = new URL(baseUrl, window.location.origin);
          u.searchParams.set("farbe", chosen);
          link.setAttribute("href", u.pathname + u.search);
        }
      });
    });
    $(".card__swatches", card).addEventListener("mouseleave", () => {
      showLayer(card, chosen);
      if (!chosen) card.classList.remove("has-swatch-choice");
    });
  });

  /* ---------- Produktseite ---------- */
  $$("[data-product]").forEach((section) => {
    const jsonEl = $("[data-product-json]", section);
    if (!jsonEl) return;
    const product = JSON.parse(jsonEl.textContent);
    const form = $("[data-product-form]", section);
    const idInput = $("[data-variant-id]", section);
    const button = $("[data-add-to-cart]", section);
    const priceEl = $(".product__price-row [data-price]", section);
    const delivery = $("[data-delivery]", section);
    const eta = $("[data-eta]", section);
    const fieldsets = $$("[data-option]", section);
    const track = $("[data-gallery-track]", section);
    const thumbs = $$("[data-gallery-thumb]", section);

    if (eta) eta.textContent = deliveryText();

    // Galerie
    const slides = track ? Array.from(track.children) : [];
    const galleryIndex = () => (track ? Math.round(track.scrollLeft / Math.max(1, track.clientWidth)) : 0);
    const goToSlide = (i, smooth = true) => {
      if (!track || !slides.length) return;
      const n = (i + slides.length) % slides.length;
      track.scrollTo({ left: n * track.clientWidth, behavior: smooth && !reduceMotion() ? "smooth" : "auto" });
    };
    if (track) {
      track.addEventListener("scroll", () => {
        const i = galleryIndex();
        thumbs.forEach((t, n) => t.setAttribute("aria-current", String(n === i)));
      }, { passive: true });
      track.addEventListener("keydown", (e) => {
        if (e.key === "ArrowRight") { e.preventDefault(); goToSlide(galleryIndex() + 1); }
        if (e.key === "ArrowLeft") { e.preventDefault(); goToSlide(galleryIndex() - 1); }
      });
      thumbs.forEach((t) => t.addEventListener("click", () => goToSlide(Number(t.dataset.galleryThumb))));
      const prev = $("[data-gallery-prev]", section);
      const next = $("[data-gallery-next]", section);
      if (prev) prev.addEventListener("click", () => goToSlide(galleryIndex() - 1));
      if (next) next.addEventListener("click", () => goToSlide(galleryIndex() + 1));
    }

    const selected = () => fieldsets.map((fs) => {
      const checked = $("input:checked", fs);
      return { position: Number(fs.dataset.option), value: checked ? checked.value : null };
    });
    const findVariant = () => {
      const sel = selected();
      return product.variants.find((v) => sel.every((s) => v.options[s.position] === s.value));
    };

    function markAvailability() {
      // Werte durchstreichen, die zusammen mit der restlichen Auswahl nicht lieferbar sind
      const sel = selected();
      fieldsets.forEach((fs) => {
        const pos = Number(fs.dataset.option);
        $$("input", fs).forEach((input) => {
          const ok = product.variants.some((v) => v.available && v.options[pos] === input.value &&
            sel.every((s) => s.position === pos || v.options[s.position] === s.value));
          input.classList.toggle("is-unavailable", !ok);
        });
      });
    }

    function applyVariant(variant, scroll = true) {
      fieldsets.forEach((fs) => {
        const checked = $("input:checked", fs);
        const label = $("[data-option-value]", fs);
        if (label && checked) label.textContent = checked.value;
      });
      markAvailability();
      if (!variant) {
        button.disabled = true;
        button.textContent = "Nicht verfügbar";
        return;
      }
      idInput.value = variant.id;
      if (priceEl) {
        priceEl.classList.toggle("price--sold-out", !variant.available);
        priceEl.innerHTML = variant.available
          ? formatMoney(variant.price) + (variant.compare_at_price > variant.price ? ` <s class="price__compare">${formatMoney(variant.compare_at_price)}</s>` : "")
          : esc(A.t.soldOut);
      }
      button.disabled = !variant.available;
      button.textContent = variant.available ? A.t.addToCart : A.t.soldOut;
      if (delivery) delivery.hidden = !variant.available;
      if (scroll && variant.featured_media && track) {
        const i = slides.findIndex((s) => s.dataset.mediaId === String(variant.featured_media.id));
        if (i >= 0) goToSlide(i);
      }
      const u = new URL(window.location.href);
      u.searchParams.set("variant", variant.id);
      u.searchParams.delete("farbe");
      history.replaceState(null, "", u.pathname + u.search);
      section.dispatchEvent(new CustomEvent("variant:change", { detail: variant, bubbles: true }));
    }

    fieldsets.forEach((fs) => fs.addEventListener("change", () => applyVariant(findVariant())));

    // Farbe aus der Produktkarte übernehmen (?farbe=Silber)
    const wanted = new URLSearchParams(window.location.search).get("farbe");
    const colorIndex = product.options.indexOf("Farbe");
    if (wanted && colorIndex >= 0) {
      const fs = fieldsets.find((f) => Number(f.dataset.option) === colorIndex);
      const input = fs && $$("input", fs).find((i) => i.value === wanted);
      if (input) {
        input.checked = true;
        applyVariant(findVariant(), false);
        const v = findVariant();
        if (v && v.featured_media) {
          const i = slides.findIndex((s) => s.dataset.mediaId === String(v.featured_media.id));
          if (i >= 0) requestAnimationFrame(() => goToSlide(i, false));
        }
      }
    } else {
      markAvailability();
    }

    if (form) {
      form.addEventListener("submit", (e) => {
        e.preventDefault();
        if (button.disabled) return;
        addItems([{ id: Number(idInput.value), quantity: 1 }], button);
      });
    }

    /* Set-Box: passende Variante (gleiche Farbe) wählen, Summen und Set-Vorteil rechnen */
    const set = $("[data-set]", section);
    if (set) {
      const rows = $$("[data-set-product]", set).map((row) => ({
        row,
        product: JSON.parse($("[data-set-json]", row).textContent),
        check: $("[data-set-check]", row),
      }));
      const colorOf = (v) => (colorIndex >= 0 && v ? v.options[colorIndex] : null);
      const pickVariant = (p, color) => {
        const ci = p.options.indexOf("Farbe");
        return (ci >= 0 && color && p.variants.find((v) => v.available && v.options[ci] === color)) || p.variants.find((v) => v.available);
      };
      const enabled = set.dataset.setEnabled === "true";
      const pair = Number(set.dataset.pair || 0);
      const triple = Number(set.dataset.triple || 0);

      function update() {
        const current = product.variants.find((v) => String(v.id) === idInput.value) || product.variants[0];
        const color = colorOf(current);
        let sum = current.price;
        let count = 1;
        rows.forEach((r) => {
          r.variant = pickVariant(r.product, color);
          $("[data-set-price]", r.row).textContent = r.variant ? formatMoney(r.variant.price) : "";
          const label = $("[data-set-variant-label]", r.row);
          label.textContent = r.variant && r.variant.title !== "Default Title" ? r.variant.title : "";
          if (r.check.checked && r.variant) { sum += r.variant.price; count++; }
        });
        $("[data-set-current-price]", set).textContent = formatMoney(current.price);
        const percent = !enabled ? 0 : count >= 3 ? triple : count === 2 ? pair : 0;
        const discount = Math.round((sum * percent) / 100);
        $("[data-set-single-row]", set).hidden = discount === 0;
        $("[data-set-single]", set).textContent = formatMoney(sum);
        $("[data-set-discount-row]", set).hidden = discount === 0;
        $("[data-set-discount]", set).textContent = `−${formatMoney(discount)} (${percent} %)`;
        $("[data-set-total]", set).textContent = formatMoney(sum - discount);
        $("[data-set-add]", set).textContent = count > 1 ? `Alle ${count} in den Warenkorb` : A.t.addToCart;
        set.hidden = !current.available;
      }
      rows.forEach((r) => r.check.addEventListener("change", update));
      section.addEventListener("variant:change", update);
      update();

      $("[data-set-add]", set).addEventListener("click", (e) => {
        const items = [{ id: Number(idInput.value), quantity: 1 }];
        rows.forEach((r) => { if (r.check.checked && r.variant) items.push({ id: r.variant.id, quantity: 1 }); });
        addItems(items, e.currentTarget);
      });
    }
  });

  /* ---------- Empfehlungen nachladen ---------- */
  $$("[data-related]").forEach(async (el) => {
    if (el.children.length) return;
    try {
      const res = await fetch(el.dataset.url);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, "text/html");
      const fresh = doc.querySelector("[data-related]");
      if (fresh && fresh.children.length) el.innerHTML = fresh.innerHTML;
    } catch (_) { /* optional */ }
  });

  /* ---------- Sortierung in Kategorien ---------- */
  $$("[data-sort]").forEach((select) =>
    select.addEventListener("change", () => {
      const u = new URL(window.location.href);
      u.searchParams.set("sort_by", select.value);
      u.searchParams.delete("page");
      window.location.href = u.toString();
    })
  );

  /* ---------- Lieferfenster überall, wo es gebraucht wird ---------- */
  $$("[data-eta-global]").forEach((el) => (el.textContent = deliveryText()));
})();
